// Helper function to get month name
export function getMonthName(month: number): string {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return months[month];
}

export function getNextYearDate(inputDate: Date) {
  const date = new Date(inputDate);
  // Get the current date components
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth();
  const currentDate = date.getDate();

  // Create a new date object for one year ahead
  const nextYearDate = new Date(currentYear + 1, currentMonth, currentDate);

  return nextYearDate;
}

export function getDatesWithDayNumber(
  fromDate: string | Date,
  toDate: string | Date,
  dayNumber: number
): { date: Date; name: string }[] {
  const result: { date: Date; name: string }[] = [];
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // Iterate through the dates from fromDate to toDate
  let currentDate = new Date(fromDate);
  const lastDate = new Date(toDate);
  while (currentDate <= lastDate) {
    // Check if the current date's day matches the given dayNumber
    if (currentDate.getDay() === dayNumber) {
      // Push an object with the date and its corresponding day name to the result array
      result.push({
        date: new Date(currentDate),
        name: daysOfWeek[dayNumber],
      });
    }
    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return result;
}

export function datesMatch(
  date1: Date | string,
  date2: Date | string
): boolean {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const dayMatch = d1.getDate() === d2.getDate();
  const monthMatch = d1.getMonth() === d2.getMonth();
  const yearMatch = d1.getFullYear() === d2.getFullYear();

  return dayMatch && monthMatch && yearMatch;
}

// Re-export timezone utilities
export * from "./timezone";

/**
 * @deprecated Use formatTimeToIST or formatDateTimeToIST from timezone.ts instead
 * This function has a bug - it creates a Date object that appears correct internally
 * but displays incorrectly when formatted because JS treats it as UTC
 */
export function convertUTCtoIST(date: Date) {
  const ISTOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5.5
  const ISTDate = new Date(date.getTime() + ISTOffset);
  return ISTDate;
}

/**
 * @deprecated Use istToUTC from timezone.ts instead
 */
export function convertUTCtoISTWithMinus(date: Date | string) {
  const d = new Date(date);
  const ISTOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5.5
  const ISTDate = new Date(d.getTime() - ISTOffset);
  return ISTDate;
}
